module.exports = __webpack_public_path__ + "static/billbartvicki-083463dfd1885de5dfe0e07a88217ac8.jpg";